import React from 'react';
// Import icons from react-icons
import { 
  IoBasketballSharp, 
  IoAmericanFootballSharp, 
  IoFootballSharp, 
  IoTennisballSharp, 
  IoBaseballSharp 
} from 'react-icons/io5';
import { 
  GiHockey, 
  GiGolfFlag 
} from 'react-icons/gi';

/**
 * Basketball icon component using react-icons
 */
export const Basketball = (props) => <IoBasketballSharp {...props} />;

/**
 * Football (American) icon component using react-icons
 */
export const Football = (props) => <IoAmericanFootballSharp {...props} />;

/**
 * Soccer icon component using react-icons
 */
export const Soccer = (props) => <IoFootballSharp {...props} />;

/**
 * Hockey icon component using react-icons
 */
export const Hockey = (props) => <GiHockey {...props} />;

/**
 * Tennis icon component using react-icons
 */
export const Tennis = (props) => <IoTennisballSharp {...props} />;

/**
 * Golf icon component using react-icons
 */
export const GolfClub = (props) => <GiGolfFlag {...props} />;

/**
 * Baseball icon component using react-icons
 */
export const Baseball = (props) => <IoBaseballSharp {...props} />;

/**
 * Collection of sport-specific icons for the app using react-icons
 */
const SportsIcons = {
  Basketball,
  Football,
  Soccer,
  Hockey,
  Tennis,
  GolfClub,
  Baseball
};

export default SportsIcons;